import React from 'react'

export default function Payments() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.6589 10.9544H13.7073V5.24854C13.7073 4.72379 13.2824 4.29985 12.7576 4.29985H3.25V3.34727C3.25 3.22249 3.27465 3.09894 3.32239 2.98376C3.37025 2.86849 3.44021 2.76383 3.52851 2.67573C3.61682 2.58754 3.7217 2.51769 3.83696 2.47017C3.95235 2.42264 4.07591 2.39822 4.20067 2.39844H14.6587C14.7833 2.39833 14.9068 2.42275 15.0221 2.47039C15.1372 2.51802 15.2419 2.58787 15.3301 2.67607C15.4183 2.76415 15.4884 2.86881 15.5361 2.98398C15.5837 3.09914 15.6084 3.22259 15.6084 3.34726V10.0055C15.6084 10.1303 15.5837 10.2536 15.5361 10.3689C15.4884 10.4841 15.4183 10.5886 15.3301 10.6768C15.2419 10.7649 15.1372 10.8347 15.0221 10.8824C14.9068 10.93 14.7833 10.9544 14.6587 10.9543L14.6589 10.9544Z'
        fill='white'
      />
      <path
        d='M0.394531 7.15127H12.7521V6.19881C12.7521 5.67406 12.3272 5.25 11.8024 5.25H1.34445C0.819693 5.25 0.394758 5.67496 0.394758 6.19881L0.394531 7.15127Z'
        fill='white'
      />
      <path
        d='M12.753 12.859V9.05469H0.394531V12.859C0.394531 12.9838 0.419177 13.1073 0.466922 13.2225C0.514777 13.3378 0.584848 13.4424 0.673154 13.5305C0.76146 13.6187 0.866232 13.6886 0.981493 13.7361C1.09688 13.7837 1.22044 13.808 1.3452 13.8078H11.8032C11.9279 13.8079 12.0513 13.7835 12.1666 13.7359C12.2818 13.6882 12.3865 13.6184 12.4747 13.5302C12.5629 13.4421 12.6329 13.3374 12.6806 13.2223C12.7284 13.1071 12.7529 12.9837 12.7529 12.859L12.753 12.859Z'
        fill='white'
      />
    </svg>
  )
}
